import COMMUNITY_MAP_ICON from '../assets/map/icons/community.png'
import GOV_SCHOOL_MAP_ICON from '../assets/map/icons/gov_school.png'
import GOV_OFFICE_MAP_ICON from '../assets/map/icons/gov_office.png'
import HKO_MAP_ICON from '../assets/map/icons/hko_station.png'
import JUDICIARY_MAP_ICON from '../assets/map/icons/judiciary.png'
import LIBRARY_MAP_ICON from '../assets/map/icons/library.png'
import HEALTH_MAP_ICON from '../assets/map/icons/health.png'

import {ReactComponent as ALL_ICON} from '../assets/control_panel/building_type/all.svg'
import {ReactComponent as GOV_OFFICE_ICON} from '../assets/control_panel/building_type/gov_office.svg'
import {ReactComponent as GOV_SCHOOL_ICON} from '../assets/control_panel/building_type/gov_school.svg'
import {ReactComponent as COMMUNITY_ICON} from '../assets/control_panel/building_type/community.svg'
import {ReactComponent as QUARTERS_ICON} from '../assets/control_panel/building_type/quarters.svg'
import {ReactComponent as HKO_ICON} from '../assets/control_panel/building_type/hko.svg'
import {ReactComponent as JUDICIARY_ICON} from '../assets/control_panel/building_type/judiciary.svg'
import {ReactComponent as HEALTH_ICON} from '../assets/control_panel/building_type/health.svg'

import {ReactComponent as AI_PALTFORM_ICON } from '../assets/control_panel/app/ai_platform.svg';
import {ReactComponent as BIMAM_ICON } from '../assets/control_panel/app/bim_am.svg';
import {ReactComponent as IBMS_ICON } from '../assets/control_panel/app/ibms.svg';
import {ReactComponent as DDS_ICON } from '../assets/control_panel/app/dds.svg';
import {ReactComponent as LIFT_SYSTEM_ICON } from '../assets/control_panel/app/lift.svg';
import {ReactComponent as PHLC_ICON } from '../assets/control_panel/app/phlc.svg';
import {ReactComponent as BRICKS_ICON } from '../assets/control_panel/app/brick.svg';
import {ReactComponent as MAINTENANCE_ICON } from '../assets/control_panel/app/maintenance.svg';
import {ReactComponent as FUNDING_ICON } from '../assets/control_panel/app/funding.svg';
import {ReactComponent as HEARTS_ICON } from '../assets/control_panel/app/hearts.svg'
import {ReactComponent as GWIN_ICON } from '../assets/control_panel/app/gwin.svg'
import {ReactComponent as CEMS_ICON } from '../assets/control_panel/app/cems.svg'
import {ReactComponent as RMS_ICON} from '../assets/control_panel/app/rms.svg'

import {ReactComponent as ELECTRICAL_ICON } from '../assets/system/electrical.svg'
import {ReactComponent as HVAC_ICON } from '../assets/system/hvac.svg'
import {ReactComponent as PLUMBING_ICON } from '../assets/system/plumbing.svg'
import {ReactComponent as LIFT_ICON } from '../assets/system/lift.svg'
import {ReactComponent as LEAKAGE_ICON } from '../assets/system/leakage.svg'
import {ReactComponent as CCTV_ICON } from '../assets/system/cctv.svg'
import {ReactComponent as FIRE_ICON } from '../assets/system/fire.svg'
import {ReactComponent as LIGHTING_ICON } from '../assets/system/lighting.svg'
import {ReactComponent as GENSET_ICON } from '../assets/system/genset.svg'

//HVAC Icon
import {ReactComponent as CHILLER_ICON } from '../assets/system/hvac/chiller.svg'
import {ReactComponent as PAU_ICON } from '../assets/system/hvac/pau.svg'
import {ReactComponent as AHU_ICON } from '../assets/system/hvac/ahu.svg'
import {ReactComponent as CRAC_ICON } from '../assets/system/hvac/crac.svg'
import {ReactComponent as COOLING_TOWER_ICON } from '../assets/system/hvac/cooling_tower.svg'
import {ReactComponent as IAQ_ICON } from '../assets/system/hvac/iaq.svg'

// Plumbing Icon
import {ReactComponent as CHILLER_WATER_ICON } from '../assets/system/plumbing/chiller_water.svg'
import {ReactComponent as CLEANSING_WATER_ICON } from '../assets/system/plumbing/cleansing_water.svg'
import {ReactComponent as CONDENSING_WATER_ICON } from '../assets/system/plumbing/condensing_water.svg'
import {ReactComponent as FLUSH_WATER_ICON } from '../assets/system/plumbing/flush_water.svg'
import {ReactComponent as HEATING_WATER_ICON } from '../assets/system/plumbing/heating_water.svg'
import {ReactComponent as PORTABLE_WATER_ICON } from '../assets/system/plumbing/portable_water.svg'
import {ReactComponent as SEA_WATER_ICON } from '../assets/system/plumbing/sea_water.svg'
import {ReactComponent as SOURCE_WATER_ICON } from '../assets/system/plumbing/source_water.svg'

// Genset
import {ReactComponent as GENSET_SUBSYSTEM_ICON } from '../assets/system/genset/genset.svg'
import {ReactComponent as UPS_ICON } from '../assets/system/genset/ups.svg'

// PV Panel Map Icon
import PV_PANEL_ICON from '../assets/map/icons/pv_panel/pvpanel.png'


export const DATE_FILTER = {
    WEEKLY:     'weekly',
    MONTHLY:    'monthly',
    YEARLY:     'yearly',
    CUSTOM:     'custom'
}

export const MODES = {
    DAILY: 'daily',
    ENERGY: 'energy',
    DISASTER: 'disaster'
}

export const ALARM_SOURCES = {
    IBMS: 1,
    CCEP: 2
}

export const BUILDING_TYPES = {
    COMMUNITY_HALL: 5,
    GOVERNMENT_OFFICE: 1,
    GOVERNMENT_SCHOOL: 3,
    HKO_STATION: 4117,
    JUDICIARY: 4,
    QUARTERS: 2,
    HEALTH: 6
}

export const SYSTEMS = {
    ELECTRICAL: 19,
    HVAC: 4,
    PLUMBING: 22,
    LIFT: 1,
    LEAKAGE: 24,
    CCTV: 16,
    FIRE: 7,
    LIGHTING: 18,
    GENSET: 3,
}

export const SYSTEM_CODES = {
    ELECTRICAL: "electrical",
    HVAC: "hvac",
    PLUMBING: "plumbing",
    LIFT: "lift",
    LEAKAGE: "water-leakage",
    CCTV: "cctv",
    FIRE: "fire-system",
    LIGHTING: "lighting",
    GENSET: "genset",
}

export const SYSTEM_CODE_MAPPING = {
    [SYSTEM_CODES.ELECTRICAL]: "EL",
    [SYSTEM_CODES.HVAC]: "HVAC",
    [SYSTEM_CODES.PLUMBING]: "PL",
    [SYSTEM_CODES.LIFT]: "LAE",
    [SYSTEM_CODES.LEAKAGE]: "LDS",
    [SYSTEM_CODES.CCTV]: "CCTV",
    [SYSTEM_CODES.FIRE]: "FS",
    [SYSTEM_CODES.LIGHTING]: "LTG",
    [SYSTEM_CODES.GENSET]: "EMG"
}

export const SYSTEMS_ICONS = {
    [SYSTEMS.ELECTRICAL]: ELECTRICAL_ICON,
    [SYSTEMS.HVAC]: HVAC_ICON,
    [SYSTEMS.PLUMBING]: PLUMBING_ICON,
    [SYSTEMS.LIFT]: LIFT_ICON,
    [SYSTEMS.LEAKAGE]: LEAKAGE_ICON,
    [SYSTEMS.CCTV]: CCTV_ICON,
    [SYSTEMS.FIRE]: FIRE_ICON,
    [SYSTEMS.LIGHTING]: LIGHTING_ICON,
    [SYSTEMS.GENSET]: GENSET_ICON
}

export const SUBSYSTEMS_ICONS = {
    "CRAC": CRAC_ICON,
    "PAU": PAU_ICON,
    "AHU": AHU_ICON,
    "Chiller": CHILLER_ICON,
    "Cooling Tower": COOLING_TOWER_ICON,
    "IAQ": IAQ_ICON,

    "Chiller Water": CHILLER_WATER_ICON,
    "Condensing Water": CONDENSING_WATER_ICON,
    "Potable Water": PORTABLE_WATER_ICON,
    "Cleansing Water": CLEANSING_WATER_ICON,
    "Flushing Water": FLUSH_WATER_ICON,
    "Source Water": SOURCE_WATER_ICON,
    "Heating Water": HEATING_WATER_ICON,
    "Sea Water": SEA_WATER_ICON,


    "Genset": GENSET_SUBSYSTEM_ICON,
    "UPS": UPS_ICON
}

export const BUILDING_TYPE_MAP_ICONS = {
    [BUILDING_TYPES.COMMUNITY_HALL]: COMMUNITY_MAP_ICON,
    [BUILDING_TYPES.GOVERNMENT_OFFICE]: GOV_OFFICE_MAP_ICON,
    [BUILDING_TYPES.GOVERNMENT_SCHOOL]: GOV_SCHOOL_MAP_ICON,
    [BUILDING_TYPES.HKO_STATION]: HKO_MAP_ICON,
    [BUILDING_TYPES.JUDICIARY]: JUDICIARY_MAP_ICON,
    [BUILDING_TYPES.QUARTERS]: LIBRARY_MAP_ICON,
    [BUILDING_TYPES.HEALTH]: HEALTH_MAP_ICON
}

export const BUILDING_TYPE_PANEL_ICONS = {
    "ALL": ALL_ICON,
    [BUILDING_TYPES.COMMUNITY_HALL]: COMMUNITY_ICON,
    [BUILDING_TYPES.GOVERNMENT_OFFICE]: GOV_OFFICE_ICON,
    [BUILDING_TYPES.GOVERNMENT_SCHOOL]: GOV_SCHOOL_ICON,
    [BUILDING_TYPES.HKO_STATION]: HKO_ICON,
    [BUILDING_TYPES.JUDICIARY]: JUDICIARY_ICON,
    [BUILDING_TYPES.QUARTERS]: QUARTERS_ICON,
    [BUILDING_TYPES.HEALTH]: HEALTH_ICON
}

export const APPLICATION_SYSTEMS_ICONS = {
    "ibms"          : IBMS_ICON,
    "dds"           : DDS_ICON,
    "hvac_ai"       : AI_PALTFORM_ICON,
    "bimam"         : BIMAM_ICON,
    "lift"          : LIFT_SYSTEM_ICON,
    "neo4j"         : BRICKS_ICON,
    "cmp"           : MAINTENANCE_ICON,
    "pf"            : FUNDING_ICON,
    "hearts"        : HEARTS_ICON,
    "gwin"          : GWIN_ICON,
    "sems"          : CEMS_ICON,
    "cvc"           : PHLC_ICON,
    "phlc"          : PHLC_ICON,
    "rms"           : RMS_ICON
}

export const PV_PANEL_MAP_ICON = PV_PANEL_ICON
